module.exports = __webpack_public_path__ + "img/19.b6918d85.svg";